const GameAspectRatioData = [
  {
    Arena5Slug: 'lets-crossword',
    AspectRatio: 0.89
  }
];

export const getAspectRatioByGame = (slug: string) => {
  const DefaultAspectRatio = 0.71;
  const found = GameAspectRatioData.find(item => item.Arena5Slug === slug);
  return found ? found.AspectRatio : DefaultAspectRatio;
};
